/* eslint-disable no-use-before-define */
import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import moment from "moment";
import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import { KeyboardDateTimePicker } from "@material-ui/pickers";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import "./schedule.css";
import { useParams } from "react-router-dom";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import MiddleHeader from '../middleHeader/middleHeader'
import add from "../../Assets/add.png";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import InputLabel from '@material-ui/core/InputLabel';
// import Site from "../team/addnewgroup";
import SitesForm from './scheduleSiteForm'
import Spinner from "./../../Global/ProcessModal";
import Colors from "./../../Global/colors";
import { useSelector, useDispatch } from "react-redux";
import {useTranslation} from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));



export default function CreateScheduleForm(props) {
  const { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const classes = useStyles();
  let history = useHistory();
  let location = useLocation();
  const [formSubmitted, setFormSubmitted] = React.useState(false);
    const [packageDetails, setPackageDetails] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [templates, setTemplates] = React.useState([]);
  const [users, setUsers] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [editMode,setEditMode]= React.useState(false);
  const [createdSchedule, setCreatedSchedule] = React.useState(null);
  const [readyForInspectionTemp, setReadyForInspectionTemp] = React.useState({});
  const [sites, setSites] = React.useState([]);
  const [templateClone, setTemplateClone] = React.useState({});
  const [loader,setLoader]=React.useState(false)
  const [formData, setFormData] = React.useState({
    template_id: location?.state?.template_id ? location.state.template_id : "",
    group_arr: [],
    assignee_arr: [],
    start_date: new Date(),
    days_to_complete: 1,
    end_date: moment().endOf("day"),
    site_id: "",
    rule: { title: "One Off", value: "ONE OFF" },
    title: "",
    weekly_string: "-",
    interval: 2,
    assign_boo: true,
    is_conduct_all: true,
  });

  console.log(users,"{{{{{{{{{{{{{{{{{{{{{{{{{{{{{")

  const { id } = useParams();
  console.log(id);

  const [formDataEdit, setFormDataEdit] = React.useState({
    template_id: "",
    group_arr: [],
    assignee_arr: [],
    start_date: new Date(),
    end_date: new Date(),
    days_to_complete: 1,
    site_id: "",
    rule: { title: "One Off", value: "ONE OFF" },
    title: "",
    weekly_string: "-",
    interval: 2,
    assign_boo: true,
    is_conduct_all: true,
  });

  console.log(formData, "formDataEdit");

  const [customDrop, setCustomDrop] = React.useState(false);
    const [currentCompany, setCurrentCompany] = React.useState();

  async function getMetaData(data) {
    await fetchTemplates(data);
    await fetchUsers(data);
    await fetchSites(data);
    await fetchGroups(data);
  }

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  if(createdSchedule){
    console.log("Created Schedule*(**********",moment(createdSchedule.start_date).format("DD MM YYYY"))
    console.log("Created Schedule*(**********",moment().format("DD MM YYYY"))
  }
  

  let data = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      setCurrentCompany(data);
      getMetaData(data);
    },
    [data]
  );

  React.useEffect(
    () => {
      getPackageDetails()
    },
    []
  );



  async function createInspection({ id, schedule_id }) {
    console.log("create inspection functuion called")
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let inspection_obj = {
      schedule_id,
      template_id: id,
      user_id: data.user_id,
      company_id: currentCompany.id,
      created_by: data.user_id,
    };

 
    // let package_inquiry = {
    //   feature_slug: "inspection_limit",
    //   company_id: currentCompany.id,
    // };

    // let query = Object.keys(package_inquiry)
    //   .map(
    //     (k) =>
    //       encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
    //   )
    //   .join("&");
    // let req = await fetch(GlobalApi + "/Package/inspection_limit?" + query, {
    //   method: "GET",
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     "Content-Type": "application/json",
    //   },
    // });

    // let reqJson = await req.json();
    // console.log("reqJson.status",reqJson)
    // if (reqJson.status === "Request is Valid") {
      fetch(GlobalApi + "/Inspection/create_inspection", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(inspection_obj),
      })
        .then((response) => response.json())
        .then(async (res1) => {
          console.log(res1);
          fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_id: res1.data.id,
              user_id: data.user_id,
              created_by: data.user_id,
              role: "Owner",
              isEditor: true,
              isOwner: true,
            }),
          })
            .then((response) => response.json())
            .then(async (res) => {
              console.log(res);

              if (packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") {
                navigator.geolocation.getCurrentPosition(function(
                  position
                ) {
                  console.log(
                    "Latitude is :",
                    position.coords.latitude
                  );
                  console.log(
                    "Longitude is :",
                    position.coords.longitude
                  );

                  fetch(
                    GlobalApi + "/Inspection/save_inspector_loc",
                    {
                      method: "post",
                      headers: new Headers({
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                      }),
                      body: JSON.stringify({
                        inspection_id: res1.data.id,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                      }),
                    }
                  )
                    .then((response) => response.json())
                    .then(async (data) => {
                      console.log(data);
                    });
                });
              }else{
                fetch(
                  GlobalApi + "/Inspection/save_inspector_loc",
                  {
                    method: "post",
                    headers: new Headers({
                      Authorization: "Bearer " + token,
                      "Content-Type": "application/json",
                    }),
                    body: JSON.stringify({
                      inspection_id: res1.data.id,
                      latitude: null,
                      longitude: null,
                    }),
                  }
                )
                  .then((response) => response.json())
                  .then(async (data) => {
                    console.log(data);
                  });
              }
              

              history.push("inspection-edit/" + res1.data.id + "/edit");
            });
        });
    // } else {
    //   swal(t("Warning"), "warning occured", "warning");
    // }
  }

  function handlePackage(e) {
    history.push(e);
  }

  

function removeDuplicates(arr) {
 

  let jsonObject = arr.map(JSON.stringify);
  let uniqueSet = new Set(jsonObject);
  let uniqueArray = Array.from(uniqueSet).map(JSON.parse);

  return uniqueArray;
}

  function handleStart(schedule_id, template_id) {
    console.log(schedule_id, template_id);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = { schedule_id, template_id };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/TemplateInspection/get_template_for_inspection?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    ).then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("Response from get_template_for_inspection?",response );
        if (response.status === "Success") {
          if (response.data) {
            createInspection(response.data);

            console.log(response, "{}{}{}{}");
          }
        } else if (response.error === "jwt expired" || response.error === "invalid token" || response.error === "invalid signature" || response.error === "Unexpected token") {
          let status =  refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleStart(schedule_id, template_id);
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  }





  const fetchSchedule = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      schedule_id: id,
    };
    console.log(templates, users, groups, sites);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_schedule_detail?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "{}{}{}{}");
        if (response.status === "Success") {
          console.log("PPPPPPPP",response);

          // let temp_obj = response.data.template_id;
          // _.filter(templates, {
          //   id: response.data.template_id,
          // });
          let group_obj = [];
          if(response.data.group_ids){
          let group_ids = JSON.parse(response.data.group_ids);
          group_obj = group_ids;
          }
          let user_obj = [];
          if (response.data.ScheduleAssignees.length >= 1) {
            response.data.ScheduleAssignees.map((v, i) => {
              user_obj.push(v.User.id);
            });
          } else {
            response.data.ScheduleAssignees.map((v, i) => {
              user_obj.push(v.User.id);
            });
          }

          let rule_obj = _.filter(Rule, {
            value: response.data.rule,
          });

          let site_obj = _.filter(sites, {
            id: response.data.site,
          });

          console.log(site_obj);

          if (
            response.data.rule == "CUSTOM WEEK" ||
            response.data.rule == "CUSTOM MONTH"
          ) {
            setCustomDrop(true);
          }

          console.log(user_obj, "user_obj");

          setFormData({
            ...formData,
            ...response.data,
            template_id: response.data.template_id,
            assignee_arr: user_obj,
            group_arr: group_obj,
            rule: rule_obj[0] ? rule_obj[0] : "",
            site_id: response.data.site,
          });

          setFormDataEdit({
            ...formDataEdit,
            ...response.data,
          });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchSchedule();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };
  if (
    id &&
    templates.length !== 0 &&
    users.length !== 0 &&
    sites.length !== 0 &&
    formDataEdit.title === ""
  ) {
    // const timer = setTimeout(() => {
    console.log(templates, users, groups, sites);

    fetchSchedule();
    // }, 3000);
    // return () => clearTimeout(timer);
  }

  const fetchTemplates = (company) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status === "Success") {
          setTemplates(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchTemplates(company);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const fetchUsers = (company) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };

    console.log("Fetch Users Api Called")
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("Response of Fetch users" , response);
        if (response.status === "Success") {
          setUsers(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchUsers(company);
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  // const fetchGroups = (company) => {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data.token;
  //   let params = {
  //     company_id: company.id,
  //   };

  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/user/get_groups?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       console.log(response);
  //       if (response.status === "Success") {
  //         setGroups(response.data);
  //       } else if (
  //         response.error === "jwt expired" ||
  //         response.error === "invalid token" ||
  //         response.error === "invalid signature" ||
  //         response.error === "Unexpected token"
  //       ) {
  //         let status = await refresh_token();
  //         console.log(status);
  //         if (status) {
  //           console.log("opopopop");
  //           fetchUsers(company);
  //         }
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  // };

    const fetchGroups = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

      fetch(GlobalApi + "/companygroups/get_all_company_groups?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log("response of group",response);
          if (response.msg === "success") {
         setGroups(response.groups);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            fetchGroups();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  function fetchSites(company) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let arr = [];
        data.data.map((value, index) => {
          //console.log(value.title);
          value.Areas.map((area, i) => {
            area.Sites.map((sites, j) => {
              console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              console.log("obj",obj);
             
            });
            setSites(arr.sort((a, b) => a.title.localeCompare(b.title)));
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
      });
  }
  const handleChangeText = (e) => {
    let { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeSelect = (name, value) => {
    console.log("::::::::::",name, value);
    if (value) {
      if (value.value === "CUSTOM MONTH") {
        setCustomDrop(true);
        value.title = "Custom Month";
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeTime = (e, name) => {
    console.log(e, name);
    // setIsOpen(false);
    setFormData({
      ...formData,
      [name]: e,
    });
  };
  // const renderInput = props => <TextField value={props.value} label={props.lable} fullWidth type="date"/>

  function getDateFormat(e) {
    console.log(e);
    if (
      formData.rule.value === "ONE OFF" ||
      formData.rule.value === "EVERY MONTH" ||
      formData.rule.value === "EVERY YEAR" ||
      formData.rule.value === "CUSTOM MONTH"
    ) {
      return "MMMM dd yyyy, h:mm";
    } else if (
      formData.rule.value === "EVERY WEEKDAY" ||
      formData.rule.value === "EVERY DAY" ||
      formData.rule.value === "CUSTOM WEEK"
    ) {
      return "h:mm aa";
    } else if (formData.rule.value === "EVERY WEEK") {
      return "EEEE h:mm aa";
    }
  }

  function getDateViews(e) {
    // console.log(e);
    if (
      formData.rule.value === "ONE OFF" ||
      formData.rule.value === "EVERY MONTH" ||
      formData.rule.value === "EVERY YEAR"
    ) {
      return ["date", "hours", "minutes"];
    } else if (
      formData.rule.value === "EVERY WEEKDAY" ||
      formData.rule.value === "EVERY DAY"
    ) {
      return ["hours", "minutes"];
    }
  }

  function HandleCustom(e) {
    let { value, name } = e.target;
    let obj = {
      value: value,
      title: "Every 2 Weeks",
    };
    if (value === "CUSTOM MONTH") {
      obj = {
        value: value,
        title: "Every 2 Months",
      };
    }

    setFormData({
      ...formData,
      [name]: obj,
    });
  }

  function handleWeekChange(index, value) {
    let weekly_arr = formData.weekly_string.split("-");
    console.log(weekly_arr);
    if (weekly_arr.indexOf(value) === -1) {
      // console.log(weekly_arr.indexOf())
      weekly_arr.push(value);
    } else {
      weekly_arr.splice(weekly_arr.indexOf(value), 1);
    }
    var uniq = weekly_arr.reduce(function(a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);
    let str = ``;

    uniq.map((v, i) => {
      if (i !== uniq.length - 1) {
        str += v + "-";
      } else {
        str += v;
        setFormData({
          ...formData,
          weekly_string: str,
        });
      }
    });

    console.log(str, uniq);
  }

  function handleCustomSave() {
    let obj = {
      value: formData.rule.value,
      title: "Every " + formData.interval + " Weeks",
    };
    if (formData.rule.value === "CUSTOM MONTH") {
      obj = {
        value: formData.rule.value,
        title: "Every " + formData.interval + " Months",
      };
    }

    setFormData({
      ...formData,
      ["rule"]: obj,
    });

    setCustomDrop(false);
  }

  function handleSubmit(proceed=false) {

    let form_obj = formData;
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let user_id = data.user_id;


    let schedule_obj = {
      template_id: formData.template_id,
      start_date: new Date(formData.start_date.toString()),
      end_date: new Date(formData.end_date.toString()),
      rule: formData.rule.value,
      site: formData.site_id,
      days_to_complete: formData.days_to_complete,
      interval: formData.interval,
      weekly_string: formData.weekly_string,
      title: formData.title,
      is_conduct_all: formData.is_conduct_all,
      created_by: user_id,
      status: "active",
      company_id: currentCompany.id,
    };
    console.log("OOOOOOOOOOO",schedule_obj);
    if (location?.state?.template_id) {
      schedule_obj.template_id = location?.state?.template_id;
    }

    console.log(schedule_obj);

    if (schedule_obj.days_to_complete < 1) {
      swal(t("Warning"), t("Atleast one day Required to complete"), "warning");
      return;
    }
    
    if (schedule_obj.template_id === "") {
      swal(t("Warning"), t("Template is Required"), "warning");
      return;
    }

    if (schedule_obj.site === "") {
      swal(t("Warning"), t("Site is Required"), "warning");
      return;
    }

    if (schedule_obj.title === "") {
      swal(t("Warning"), t("Title is Required"), "warning");
      return;
    }

    if (formData.assignee_arr.length == 0 && formData.group_arr.length == 0) {
      swal(t("Warning"), t("Atleast One Assignee / Group is Required"), "warning");
      return;
    }


    setLoader(true)
    fetch(GlobalApi + "/Schedule/create_schedule", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(schedule_obj),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.status === "Success") {
          console.log("data from create schedule >>>>>>>>",data)
          setCreatedSchedule(data.data)
          let ass_req = formData.assign_boo
            ? formData.assignee_arr
            : formData.group_arr;

          // if (formData.assign_boo) {
            let assigneeArr = formData.assignee_arr.map(item => item)
              let req = await fetch(
                GlobalApi + "/ScheduleAssignee/create_schedule_assignee",
                {
                  method: "post",
                  headers: new Headers({
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                  }),
                  body: JSON.stringify({
                    proceed,
                    schedule_id: data.data.id,
                    user_id: JSON.stringify(assigneeArr),
                    group_id: JSON.stringify(formData.group_arr),
                    group_flag: formData.group_arr.length > 0 ? true : false,
                    created_by: user_id,
                    status: "active",
                  }),
                }
              );

              let reqJson = await req.json();
              console.log("ok", reqJson);
              if(reqJson.status == 'Success'){
                await getTemplate(data.data);
                  setFormData({
                    template_id: "",
                    group_arr: [],
                    assignee_arr: [],
                    start_date: new Date(),
                    days_to_complete:1,
                    end_date: moment().endOf("day"),
                    site_id: "",
                    rule: { title: "One Off", value: "ONE OFF" },
                    title: "",
                    weekly_string: "",
                    interval: 2,
                    assign_boo: true,
                    is_conduct_all: true,
                  });
                  setFormSubmitted(true);
                  console.log("alet");
                  setLoader(false)
                  swal(
                    t("Success"),
                    t("Schedule has been created successfully"),
                    "success"
                  );
              
              }else if(reqJson.status == "schedule conflict"){
                swal({
                  title: t("Do you want to proceed?"),
                  text: reqJson.error,
                  icon: "warning",
                  buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
                  dangerMode: true,
                }).then(async function(isConfirm) {
                
                  if (isConfirm) {
                    handleSubmit(true)

                  } else {
                    setLoader(false)
                   return;
                  }});
              }else {
                swal(
                  t("Error"),
                  t("Something Went Wrong"),
                  "error"
                );
                setLoader(false)
              }
              // if (i === formData.assignee_arr.length - 1) {
              //   await getTemplate(data.data);
               
              //   setFormData({
              //     template_id: "",
              //     group_obj: null,
              //     assignee_arr: [],
              //     start_date: new Date(),
              //     days_to_complete:1,
              //     end_date: moment().endOf("day"),
              //     site_id: "",
              //     rule: { title: "One Off", value: "ONE OFF" },
              //     title: "",
              //     weekly_string: "",
              //     interval: 2,
              //     assign_boo: true,
              //     is_conduct_all: true,
              //   });
              //   setFormSubmitted(true);
              //   console.log("alet");
              //   setLoader(false)
              //   swal(
              //     t("Success"),
              //     "Schedule has been created successfully",
              //     "success"
              //   );
              // }
            
          // } else {
            
          //   let req = await fetch(
          //     GlobalApi + "/ScheduleAssignee/create_schedule_assignee",
          //     {
          //       method: "post",
          //       headers: new Headers({
          //         Authorization: "Bearer " + token,
          //         "Content-Type": "application/json",
          //       }),
          //       body: JSON.stringify({
          //         proceed,
          //         schedule_id: data.data.id,
          //         user_id: formData.group_obj,
          //         created_by: user_id,
          //       }),
          //     }
          //   );

          //   let reqJson = await req.json();
          //   console.log("ok", reqJson);
          //   if(reqJson.status == 'Success'){
          //     await getTemplate(data.data);
          //   }else if(reqJson.status == "schedule conflict"){
          //     swal({
          //       title: t("Do you want to proceed?"),
          //       text: reqJson.error,
          //       icon: "warning",
          //       buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
          //       dangerMode: true,
          //     }).then(async function(isConfirm) {
                
          //       if (isConfirm) {
          //         handleSubmit(true)
          //       } else {
          //         setLoader(false)
          //        return;
          //       }});
          //   }
           
          // }
        }
      });

    console.log(schedule_obj);
  }

  const getTemplate = async (obj) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      // return <Redirect to={"/signin"} />;
    }
    console.log("()()()", obj);
    // this.setState({ loader: true });
    var params = {
      template_id: obj.template_id,
      // template_id: "1744c680-998c-470c-84fd-c7e03cb94360",
    };

    //var token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIzMWM0YmUxLTU3NmItNDc3Yi05ZGZlLTIwMWYzYWQ0ZmM0ZCIsImVtYWlsIjoiYWJkdWxAZ21haWwuY29tIiwiaWF0IjoxNTk0NjMzMjkyLCJleHAiOjE1OTUzNTMyOTJ9.iJKptiq4-4RGC3PawMAjz2iSeUnGwWhIujgKZJD7zFA'
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(GlobalApi + "/Template/get_template_details?" + query, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {

       
        if (res.status === "Success") {
          var data = res.data;
         
          var sections = [];
          var title = data.title;
          var template_Id = data.id;
          var des = data.description;

 // #############################################################################

          await data.Sections.map((sec) => {
            var checklist = [];
            var checklistTest = [];
            sec.CheckLists.map((item) => {
              console.log("HERE***********",item);
              
              var responseList = [];
              var conditionalList = [];
              var subQuestionList = [];

              if (item.data_type == "Custom" || item.data_type == "Global") {
                item.ResponseSets.map((r) => {
                  var item = {
                    id: r.response_id,
                    title: r.title,
                    position: r.position,
                    weight:r.weight
                  };
                  responseList.push(item);
                 
                });
                var responseLibrary = {
                  id: item.id,
                  responses: removeDuplicates(responseList.sort(
                    (a, b) => a.position - b.position
                  )),
                };
              }

            
              if (item.is_conditional == "yes") {
                var list = sec.CheckLists.filter((x) => x.parent_id == item.id && x?.type !== "subquestion");
                var responseListCQ = [];
                list.map((item) => {
                  
                  if (item.data_type == "Custom" || item.data_type == "Global") {
                    item.ResponseSets.map((r) => {
                      
                      var responseItem = {
                        id: r.response_id,
                        title: r.title,
                        position: r.position,
                        weight:r.weight
                      };
                      responseListCQ.push(responseItem);
                    });
                    
                    var responseLibraryCQ = {
                      id: item.id,
                      responses: removeDuplicates(responseListCQ.sort(
                        (a, b) => a.position - b.position
                      )),
                    };
                  }
                  var conditionalItem = {
                    id: item.id,
                    title: item.title,
                    dataType: item.data_type,
                    position: item.position,
                    status: "added",
                    mandatory: item.is_mandatory,
                    multiselection: item.is_multiple_allowed,
                    condition: item.condition,
                    conditionValue: item.condition_value,
                    conditional: item.is_conditional,
                    parent: item.parent_id,
                    is_subquestion: item.is_subquestion,
                    type: item.type,
                    isopen: "no",
                    // conditionalList: [],
                    // subQuestionList: [],
                    responseLibrary:
                      item.data_type == "Custom" || item.data_type == "Global"
                        ? responseLibraryCQ
                        : [],
                  };
                  conditionalList.push(conditionalItem);
                });
                //alert(JSON.stringify(conditionalList))
              }

              if (item.is_subquestion == "yes") {
                var list = sec.CheckLists.filter((x) => x.parent_id == item.id && x.type && x.type == "subquestion");
                var responseListSQ = [];
    
                list.map((item) => {
                  //alert(JSON.stringify(item.ResponseSets))
                  if (item.data_type == "Custom" || item.data_type == "Global") {
                    item.ResponseSets.map((r) => {
                      var responseItem = {
                        id: r.response_id,
                        title: r.title,
                        position: r.position,
                        weight: r.weight,
                      };
                      responseListSQ.push(responseItem);
                    });
                    //alert(JSON.stringify(item.ResponseSets))
                    var responseLibrarySQ = {
                      id: item.id,
                      responses: removeDuplicates(responseListSQ.sort(
                        (a, b) => a.position - b.position
                      )),
                    };
                  }
                  var subQuestionItem = {
                    id: item.id,
                    title: item.title,
                    dataType: item.data_type,
                    position: item.position,
                    status: "added",
                    mandatory: item.is_mandatory,
                    multiselection: item.is_multiple_allowed,
                    condition: item.condition,
                    conditionValue: item.condition_value,
                    conditional: item.is_conditional,
                    is_subquestion: item.is_subquestion,
                    type: item.type,
                    parent: item.parent_id,
                    isopen: "no",
                    // conditionalList: [],
                    // subQuestionList: [],
                    responseLibrary:
                      item.data_type == "Custom" || item.data_type == "Global"
                        ? responseLibrarySQ
                        : [],
                  };
                  subQuestionList.push(subQuestionItem);
                });
              
              }


              var newChecklist = {
                id: item.id,
                title: item.title,
                dataType: item.data_type,
                position: item.position,
                status: "added",
                mandatory: item.is_mandatory,
                multiselection: item.is_multiple_allowed,
                condition: item.condition,
                conditionValue: item.condition_value,
                conditional: item.is_conditional,
                is_subquestion: item.is_subquestion,
                type: item.type,
                parent: item.parent_id,
                isopen: "no",
                isopenSub: "no",
                conditionalList: conditionalList.sort(function(a, b) {
                  return a.position - b.position;
                }),
                subQuestionList: subQuestionList.sort(function(a, b) {
                  return a.position - b.position;
                }),
                responseLibrary:
                  item.data_type == "Custom" || item.data_type == "Global"
                    ? responseLibrary
                    : [],
              };

              console.log("newChecklist>>",newChecklist)

              if (item.parent_id == null) checklist.push(newChecklist);
            });


           
            var sectionList = {
              template: { id: sec.id },
              list: checklist.sort(function(a, b) {
                return a.position - b.position;
              }),
            };

            var section = {
              id: sec.id,
              title: sec.title,
              type: sec.type,
              status: "added",
              position: sec.position,
              checklist: sectionList,
            };
           
            sections.push(section);
           
          });
          var blank_template = {
            sections,
          };
// #############################################################################

          await handleBack(
            title,
            des,
            template_Id,
            blank_template.sections.sort(function(a, b) {
              return a.position - b.position;
            }),
            obj.id
          );
          //alert(JSON.stringify(this.state.template))
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        alert(err);
        console.log(err, "error");
      });
  };

  const handleBack = async (
    title,
    description,
    template_id,
    clone_template,
    schedule_id
  ) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      // return <Redirect to={"/signin"} />;
    }

    // var action = this.props.props.history.location.state.action;
    if (true) {
      // this.setState({ loader: true });
      //var user='231c4be1-576b-477b-9dfe-201f3ad4fc4d'
      var user = data.user_id;
      var obj = {
        title: title,
        schedule_id: schedule_id,
        company_id: currentCompany.id,
        description: description,
        // schedule_id: "p[p[",
        template_id: template_id,
        status: "active",
        created_by: user,
      };

      console.log("template", "___----___");
      //var token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIzMWM0YmUxLTU3NmItNDc3Yi05ZGZlLTIwMWYzYWQ0ZmM0ZCIsImVtYWlsIjoiYWJkdWxAZ21haWwuY29tIiwiaWF0IjoxNTk0NjMzMjkyLCJleHAiOjE1OTUzNTMyOTJ9.iJKptiq4-4RGC3PawMAjz2iSeUnGwWhIujgKZJD7zFA'
      var token = data.token;
      let reqTemplate = await fetch(
        GlobalApi + "/TemplateInspection/create_template",
        {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        }
      );
      // .then((response) => response.json())
      // .then(async (res) => {
      let res = await reqTemplate.json();
      // console.log(res.data);
      if (res.status === "Success") {
        for (let section of clone_template) {
          // if (section.status == "New")
          await addSection(
            section.title,
            res.data.id,
            user,
            section.checklist.list,
            token,
            section.type,
            section.position
          );
        }

        setReadyForInspectionTemp(res.data)
        // setFormData({
        //   template_id: "",
        //   group_obj: null,
        //   assignee_arr: [],
        //   start_date: new Date(),
        //   end_date: new Date(),
        //   site_id: "",
        //   rule: { title: "One Off", value: "ONE OFF" },
        //   title: "",
        //   weekly_string: "",
        //   interval: 2,
        //   assign_boo: true,
        //   is_conduct_all: true,
        // });
        
        
        // if(!editMode){
        //   swal(t("Success"), "Schedule has been created successfully", "success");
        // }
        // setEditMode(false)
       
        // await this.setState({
        //   loader: false,
        //   IsNewTemplate: false,
        //   templateId: res.data.id,
        // });
        // alert("New template has been created successfully");
      } else if (
        res.error === "jwt expired" ||
        res.error === "invalid token" ||
        res.error === "invalid signature" ||
        res.error == "Unexpected token"
      ) {
        let status = await refresh_token();
        console.log(status);
        if (status) {
          console.log("opopopop");
          handleBack();
        }
      }
      // })
      // .catch((err) => {
      //   console.log(err, "error");
      // });
    }
  };

  const addSection = async (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    console.log("obj", "section");
    let sectionReq = await fetch(
      GlobalApi + "/SectionInspection/create_section",
      {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(obj),
      }
    );
    let res = await sectionReq.json();
    // console.log(res.data);
    if (res.status === "Success") {
      //===================== Add checklist===============//
      await checklist.map(async (item) => {

        console.log("JJJJ",item)

        await addChecklistItem(
          item.title,
          res.data.id,
          user,
          item.position,
          item.dataType,
          token,
          item.responseLibrary,
          item.mandatory,
          item.multiselection,
          item.condition,
          item.conditionValue,
          item.conditional,
          item.parent,
          item.conditionalList,
          item.type,
          item.is_subquestion,
          item.subQuestionList
        );
      });

      //==================================================//
    } else if (
      res.error === "jwt expired" ||
      res.error === "invalid token" ||
      res.error === "invalid signature" ||
      res.error == "Unexpected token"
    ) {
      let status = await refresh_token();
      // console.log(status);
      if (status) {
        // console.log("opopopop");
        addSection(title, template_id, user, checklist, token, type, position);
      }
    }
  };

  const addChecklistItem = async (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList = [],
    type,
    is_subquestion,
    subQuestionList = [],
  ) => {
    console.log("check item");
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type: type,
      is_subquestion: is_subquestion,
    };
    var token = token;
    let checkReq = await fetch(
      GlobalApi + "/CheckListInspection/create_check_list",
      {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(obj),
      }
    );
    // .then((response) => response.json())
    // .then(async (res) => {
    let res = await checkReq.json();
    // console.log(res.data);
    if (res.status === "Success") {
      //===================== Add checklist===============//
      if (dataType == "Custom" || dataType == "Global") {
        // responseLibrary.responses.map(async (r) => {
        //   // await addResponseLibrary(r.title, res.data.id, r.id, user, token);
        // });

        let req = await fetch(
          GlobalApi + "/ResponseSetInspection/create_response_sets",
          {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              check_id: res.data.id,
              responses: responseLibrary.responses,
            }),
          }
        );
        let reqJson = await req.json();
        console.log("REEEEEEE", reqJson, {
          check_id: res.data.id,
          responses: responseLibrary.responses,
        });
      }


      
      //==================================================//
      //===================== Add Conditional checklist===============//
      if (conditional == "yes") {
        await conditionalList.map(async (item) => {
          var obj_cond = {
            title: item.title,
            section_id,
            status: "active",
            created_by: user,
            position: item.position,
            data_type: item.dataType,
            is_mandatory: item.mandatory,
            is_multiple_allowed: item.multiselection,
            condition: item.condition,
            condition_value: item.conditionValue,
            is_conditional: item.conditional,
            parent_id: res.data.id,
            type: item.type,
            is_subquestion: item.is_subquestion,
          };
          let req_cond = await fetch(
            GlobalApi + "/CheckListInspection/create_check_list",
            {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify(obj_cond),
            }
          );

          let req_cond_json = await req_cond.json();
          if (item.dataType == "Custom" || item.dataType == "Global") {
            // item.responseLibrary.responses.map((r) => {
            //   addResponseLibrary(
            //     r.title,
            //     req_cond_json.data.id,
            //     r.id,
            //     user,
            //     token
            //   );
            // });
            await fetch(
              GlobalApi + "/ResponseSetInspection/create_response_sets",
              {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  check_id: req_cond_json.data.id,
                  responses: item.responseLibrary.responses.sort(
                    (a, b) => a.position - b.position
                  ),
                }),
              }
            );
          }
          console.log("op", req_cond_json.data?.parent_id);
        });
      }

      if (is_subquestion == "yes") {
        await subQuestionList.map(async (item) => {
         var obj_cond = {
            title: item.title,
            section_id,
            status: "active",
            created_by: user,
            position: item.position,
            data_type: item.dataType,
            is_mandatory: item.mandatory,
            is_multiple_allowed: item.multiselection,
            condition: item.condition,
            condition_value: item.conditionValue,
            is_conditional: item.conditional,
            parent_id: res.data.id,
            type: item.type,
            is_subquestion: item.is_subquestion,
          };
          let req_cond = await fetch(
            GlobalApi + "/CheckListInspection/create_check_list",
            {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify(obj_cond),
            }
          );

          let req_cond_json = await req_cond.json();
          if (item.dataType == "Custom" || item.dataType == "Global") {
            // item.responseLibrary.responses.map((r) => {
            //   addResponseLibrary(
            //     r.title,
            //     req_cond_json.data.id,
            //     r.id,
            //     user,
            //     token
            //   );
            // });
            await fetch(
              GlobalApi + "/ResponseSetInspection/create_response_sets",
              {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  check_id: req_cond_json.data.id,
                  responses: item.responseLibrary.responses.sort(
                    (a, b) => a.position - b.position
                  ),
                }),
              }
            );
          }
          console.log("op", req_cond_json.data?.parent_id);
        });
      }

      //==================================================//
    } else if (
      res.error === "jwt expired" ||
      res.error === "invalid token" ||
      res.error === "invalid signature" ||
      res.error == "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");

      }
    }
  };

  const addResponseLibrary = (title, check_id, response_id, user, token) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
    };
    var token = token;
    fetch(GlobalApi + "/ResponseSetInspection/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        // console.log(res.data);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            // addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  function handleEdit() {
    setEditMode(true)
    console.log("edit");
    let form_obj = formData;
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let user_id = data.user_id;
    console.log(form_obj);

    let schedule_obj = {
      template_id: formData.template_id,
      start_date: new Date(formData.start_date.toString()),
      end_date: new Date(formData.end_date.toString()),
      rule: formData.rule.value,
      site: formData.site_id,
      interval: formData.interval,
      weekly_string: formData.weekly_string,
      title: formData.title,
      is_conduct_all: formData.is_conduct_all,
      created_by: user_id,
      status: "active",
      schedule_id: formData.id,
    };


    if (formData.template_id.id !== formDataEdit.template_id) {
      console.log("errer");
      setLoader(true)
      fetch(GlobalApi + "/Schedule/edit_schedule", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(schedule_obj),
      })
        .then((response) => response.json())
        .then(async (data) => {
          console.log(data);
          if (data.status === "Success") {
            let assigneeArr = formData.assignee_arr.map(item => item)

                let req = await fetch(
                  GlobalApi + "/ScheduleAssignee/edit_schedule_assignee",
                  {
                    method: "post",
                    headers: new Headers({
                      Authorization: "Bearer " + token,
                      "Content-Type": "application/json",
                    }),
                    body: JSON.stringify({
                      schedule_id: formData.id,
                      user_id: assigneeArr,
                      group_id: JSON.stringify(formData.group_arr),
                      group_flag: formData.group_arr.length > 0 ? true : false,
                      created_by: user_id,
                      status: "active",
                      // delete: i == 0,
                    }),
                  }
                );

                let reqJson = await req.json();
             

                console.log("req",reqJson)

                if(reqJson.status == "Success"){
                 
                  setLoader(false)
                  fetchSchedule()
                  swal(t("Success"), t("Schedule has been updated Successfullly"), "success");
                  getTemplate({ ...schedule_obj, schedule_id: formData.id });
                }else{
                  setLoader(false);
                  swal(t("Error"), t("Unable To Save"), "error");
                }
           
          }
        });
    } else {
      setLoader(true)
      fetch(GlobalApi + "/Schedule/edit_schedule", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(schedule_obj),
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === "Success") {
            console.log(formData.assignee_arr);

            // converting the array of objects to array of ids
            let assigneeArr = formData.assignee_arr.map(item => item.id)
               
                
            let req = await fetch(
              GlobalApi + "/ScheduleAssignee/edit_schedule_assignee",
              {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  schedule_id: data.data.id,
                  user_id:assigneeArr,
                  group_id: JSON.stringify(formData.group_arr),
                  group_flag: formData.group_arr.length > 0 ? true : false,
                  created_by: user_id,
                  status: "active",
                
                }),
              }
            );
            setLoader(false)
            swal(t("Success"), t("Schedule has been updated Successfullly"), "success");
          }
        });
    }
  }

  async function handleResume() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/Schedule/edit_schedule", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        schedule_id: formData.id,
        status: "active",
      }),
    });

    setFormDataEdit({
      ...formDataEdit,
      status: "active",
    });
  }

  async function handlePause() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    await fetch(GlobalApi + "/Schedule/edit_schedule", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        schedule_id: formData.id,
        status: "pause",
      }),
    });

    setFormDataEdit({
      ...formDataEdit,
      status: "pause",
    });
  }
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    fetchSites(data);
  };

  const handleDelete =async () =>{
    swal({
      text: t("Are you sure You Want to Delete This Schedule?"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        let localstorage = localStorage.getItem("UserData");
        var data = JSON.parse(localstorage);
        let token = data.token;
        let package_inquiry = {
          schedule_id: formData.id,
        };
    
        let query = Object.keys(package_inquiry)
          .map(
            (k) =>
              encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
          )
          .join("&");


          let req = await fetch(
            GlobalApi + "/Schedule/delete_schedule?" + query,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
            }
          );
      
          let reqJson = await req.json();
          if(reqJson.msg == "success"){
            history.goBack()
            swal(t("Success"), t("Schedule has been Deleted"), "success");
            
          }else{
            swal(t("Error"),reqJson.error, "error");
          }
      } else {
        console.log("Canceled");
      }
    });

   
  }

  console.log(formData.template_id);

  let weekly_arr = formData.weekly_string.split("-");
  // if(loader){
  //   return (
  //     <Spinner/>
  //   )
  // }
  // else{
  return <Container>
      <form noValidate autoComplete="off">
        <Grid container spacing={2}>
          <Spinner show={loader} />
          {location?.state?.template_id ? "" : <Grid item xs={12} md={6}>
              <FormControl variant="outlined" size="small" style={{ width: "100%", height: "40px" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                  Templates
                </InputLabel>
                <Select size="small" style={{ backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={formData.template_id} onChange={(e) => handleChangeSelect("template_id", e.target.value)} label="Templates">
                  {templates.map((item, index) => {
                    return <MenuItem value={item.id}>{item.title}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>}

          <Grid item xs={12} md={6}>


            
              <FormControl variant="outlined" size="small" style={{ width: "100%", height: "40px" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                  {t("Assignees")}
                </InputLabel>
                <Select multiple size="small" style={{ backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={formData.assignee_arr} onChange={(e) => handleChangeSelect("assignee_arr", e.target.value)} label={t("Assignees")}>
                  {users.map((item, index) => {
                    return <MenuItem value={item.id}>
                        {item.first_name + " " + item.last_name}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
         <FormControl variant="outlined" size="small" style={{ width: "100%", height: "40px" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                {t("Groups")}
                </InputLabel>
                <Select multiple size="small" style={{ backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={formData?.group_arr}  onChange={(e) => handleChangeSelect("group_arr", e.target.value)} label="Group">
                {groups.map((item, index) => {
                    return <MenuItem value={item.id}>
                        {item.group_name}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl>
          </Grid>

        

          <Grid item xs={12} md={6}>
            <Autocomplete disableClearable id="country-select-demoss" fullWidth options={Rule} style={{ backgroundColor: "#f7f9fb" }} size="small" onChange={(e, v) => handleChangeSelect("rule", v)} value={formData.rule} autoHighlight getOptionLabel={(option) => option.title} renderOption={(option) => <React.Fragment>
                  {option.title}
                </React.Fragment>} renderInput={(params) => <TextField {...params} label={t("How Often")} variant="outlined" inputProps={{ ...params.inputProps, autoComplete: "new-password" }} />} />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label={t("Days to Complete Inspection")} type="number" style={{ backgroundColor: "#f7f9fb" }} fullWidth size="small" name="days_to_complete" variant="outlined" InputProps={{ inputProps: { min: 1 } }} id="outlined-basic" value={formData.days_to_complete} onChange={handleChangeText} />
          </Grid>

          {customDrop && <Grid item xs={12}>
              {customDrop && <Paper variant="outlined" square style={{ padding: 20 }}>
                  <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
                    <Grid item>
                      <span style={{ fontWeight: "bold", fontSize: 16 }}>
                        {t("Every")}
                      </span>
                    </Grid>
                    <Grid item>
                      <TextField type="number" name="interval" size="small" autoComplete="off" variant="outlined" id="outlined-basic" value={formData.interval // label="Interval" // fullWidth
                        } style={{ backgroundColor: "#f7f9fb" }} onChange={handleChangeText} />
                    </Grid>
                    <Grid item>
                      <FormControl variant="outlined" style={{ width: 200, height: "40px", backgroundColor: Colors.globalColor9 }}>
                        <Select style={{ width: 200, height: "40px", backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined" id="demo-simple-select-outlined" value={formData.rule.value} onChange={HandleCustom} size="small" name="rule">
                          <MenuItem value={"CUSTOM MONTH"}>{t("Month")}</MenuItem>
                          <MenuItem value={"CUSTOM WEEK"}>{t("Week")}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {formData.rule.value === "CUSTOM WEEK" && <Grid item xs={12}>
                        <span className={weekly_arr.findIndex((x) => x == "0") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(0, "0")}>
                          S
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "1") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(1, "1")}>
                          M
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "2") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(2, "2")}>
                          T
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "3") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(3, "3")}>
                          W
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "4") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(4, "4")}>
                          T
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "5") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(5, "5")}>
                          F
                        </span>
                        <span className={weekly_arr.findIndex((x) => x == "6") == -1 ? "weekly-btn" : "weekly-btn-selected"} onClick={() => handleWeekChange(6, "6")}>
                          S
                        </span>
                      </Grid>}
                    <Grid container spacing={2} style={{ margin: 5 }}>
                      <Grid item>
                        <Button className="addBtn" variant="contained" onClick={handleCustomSave} style={{ backgroundColor: Colors.globalColor8, color: "white" }}>
                          {t("Save")}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button variant="contained" className="cancelBtn" onClick={() => setCustomDrop(false)}>
                          {t("Cancel")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>}
            </Grid>}

          <Grid item xs={12} md={6}>
            <KeyboardDateTimePicker fullWidth inputVariant="outlined" style={{ backgroundColor: "#f7f9fb" }} id="outlined-basic" size="small" value={formData.start_date} onChange={(e) => handleChangeTime(e, "start_date")} label={t("Start Date")} views={getDateViews()} format={getDateFormat()} />
          </Grid>
          <Grid item xs={12} md={6}>
            <KeyboardDateTimePicker fullWidth inputVariant="outlined" id="outlined-basic" style={{ backgroundColor: "#f7f9fb" }} size="small" value={formData.end_date} onChange={(e) => handleChangeTime(e, "end_date")} label={t("End Date")} views={getDateViews()} format={getDateFormat()} />
          </Grid>

          <Grid item xs={12} md={6} spacing={2} style={{ flexDirection: "rows", display: "flex" }}>
            <Grid item xs={11} style={{ margin: "0" }}>
              {/* <Autocomplete id="country-select-demoss" fullWidth size="small" style={{ backgroundColor: "#f7f9fb" }} options={sites} value={formData.site_id} autoHighlight getOptionLabel={(option) => option.title} renderOption={(option) => <React.Fragment>
                    {option.title}
                  </React.Fragment>} onChange={(e, v) => handleChangeSelect("site_id", v)} renderInput={(params) => <TextField {...params} label="Site" variant="outlined" inputProps={{ ...params.inputProps, autoComplete: "new-password" }} />} /> */}
             <FormControl variant="outlined" size="small" style={{ width: "100%", height: "40px" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                  {t("Site")}
                </InputLabel>
                <Select  size="small" style={{ backgroundColor: "#f7f9fb" }} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" value={formData.site_id} onChange={(e) => handleChangeSelect("site_id", e.target.value)} label="Site">
                  {sites.map((item, index) => {
                    console.log("OOO",item)
                    return <MenuItem value={item.id}>
                        {item.title}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl> 
            </Grid>
            <Grid style={{ alignSelf: "center", cursor: "pointer", margin: 0 }} onClick={handleClickOpen}>
              <Button style={{ backgroundColor: "#043077", color: "white",marginRight:language =="ar" && "10px", marginLeft:language =="ar" && "10px", paddingTop: "12px", paddingBottom: "12px" }}>
                {" "}
                <img src={add} width={15} height={15} alt="+" />{" "}
              </Button>
              {/* <AddIcon style={{ color: "#043077", }} /> */}
            </Grid>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField label={t("Title")} type="text" fullWidth size="small" style={{ backgroundColor: "#f7f9fb" }} name="title" variant="outlined" id="outlined-basic" value={formData.title} onChange={handleChangeText} />
          </Grid>
          <Grid item>
            <Button variant="contained" type="submit" className="addBtn" component="span" onClick={()=>{formDataEdit.title === "" ? handleSubmit() : handleEdit()}}>
              {t("Save")}
            </Button>
          </Grid>
          {formDataEdit.title !== "" && <Grid item>
              {formDataEdit.status === "active" ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={handlePause}>
                  {t("Pause")}
                </Button> : <Button variant="contained" type="submit" className="addBtn" component="span" onClick={handleResume}>
                  {t("Resume")}
                </Button>}
            </Grid>}
            {formDataEdit.title !== "" && <Grid item>
            <Button variant="contained" type="submit" className="deleteBtn" component="span" onClick={handleDelete}>
                  {t("Delete")}
                </Button>
            </Grid>}
          <Grid item>
            <Button variant="contained" className="cancelBtn" onClick={() => history.goBack()}>
              {t("Cancel")}
            </Button>
          </Grid>
          {formSubmitted && <Grid item>
              {moment(createdSchedule?.start_date).format("DD MM YYYY") === moment().format("DD MM YYYY") ? <>
                  {packageDetails && (packageDetails?.inspection_limit != "Unlimited" ? parseInt(packageDetails.inspection_limit) > parseInt(packageDetails.inspection_count) : true) ? <Button className="addBtn" style={{ backgroundColor: Colors.globalColor8, color: "white" }} variant="contained" onClick={() => handleStart(createdSchedule.id, readyForInspectionTemp.template_id)}>
                      Let's get started
                    </Button> : <Button onClick={() => {
                        handlePackage("/update_package");
                      }} className="ctBtn">
                      Upgrade package
                    </Button>}
                </> : <Button className="addBtn" style={{ backgroundColor: "#043077" }} variant="contained" onClick={() => history.push("/schedule")}>
                  Goto Schedule
                </Button>}
            </Grid>}
        </Grid>
      </form>
      <div>
        <Dialog onClose={handleClose} aria-labelledby="max-width-dialog-title" open={open} fullWidth={true} maxWidth={"lg"} scroll={"paper"}>
          <React.Fragment>
            <Grid item xs={12} style={{ alignSelf: "flex-end", cursor: "pointer" }} onClick={handleClose}>
              <CloseIcon fontSize="large" style={{ color: "#043077" }} />
            </Grid>
            <SitesForm />
            {/* <Site /> */}
          </React.Fragment>
        </Dialog>
      </div>
    </Container>;
        // }
}

const Rule = [
  {
    title: "One Off",
    value: "ONE OFF",
  },
  {
    title: "Every Day",
    value: "EVERY DAY",
  },
  {
    title: "Every Weekday",
    value: "EVERY WEEKDAY",
  },
  {
    title: "Every Week",
    value: "EVERY WEEK",
  },
  {
    title: "Every Month",
    value: "EVERY MONTH",
  },
  {
    title: "Every Year",
    value: "EVERY YEAR",
  },
  {
    title: "Custom Month",
    value: "CUSTOM MONTH",
  },
  {
    title: "Custom Week",
    value: "CUSTOM WEEK",
  },
];
